(function(){
    'use strict';

    angular
       .module('appback')
       .factory('PedidosService', PedidosService);

   PedidosService.$inject = ['$http'];

   function PedidosService($http){


       var service= {
          getProductosByProveedor:getProductosByProveedor,
          getPedidosPendientes:getPedidosPendientes,
          getPedido:getPedido,
          crearPedido:crearPedido,
          finalizarPedido:finalizarPedido,
          setPedidoAccion:setPedidoAccion,
          recepcionarLineasPedido:recepcionarLineasPedido,
          liberarStock:liberarStock,
          rechazarStock:rechazarStock,
          getMovimientosPedido:getMovimientosPedido,
          guardarUbicacion:guardarUbicacion,
          getValidacionesStock:getValidacionesStock,
          guardarValidacion:guardarValidacion,
          finalizarValidacion:finalizarValidacion,
          getTipoCoste:getTipoCoste,
          guardarFabricacionExterna:guardarFabricacionExterna,
          checkStockPendiente:checkStockPendiente,
          getTransportePedido:getTransportePedido,
          guardarTransportePedido:guardarTransportePedido,
          getSameLote:getSameLote
       };

       return service;

       function guardarFabricacionExterna(linea_stock, pedido_id,callback)
       {

           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }
           const copia_linea_stock = angular.copy(linea_stock);
           delete copia_linea_stock.formFabricacion;
           var postParams = $.param(
            {
                "pedido_id":pedido_id,
                "linea_stock":JSON.stringify(copia_linea_stock)
            }
           );

           $http.post('/backend/pedidos/guardarfabricacionexterna',  postParams  , config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }
       function recepcionarLineasPedido(pedidoID, transporte, lineasPedido, divisa_proveedor_id,callback)
       {

           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }
           var postParams = $.param(
            {
                "pedido_id":pedidoID,
                "transporte":JSON.stringify(transporte),
                "lineas_pedido":JSON.stringify(lineasPedido),
                "divisa_proveedor_id":divisa_proveedor_id
            }
           );
           $http.post('/backend/pedidos/recepcionarlineaspedido',  postParams  , config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }
       function guardarUbicacion(stock, pedidoID, callback)
       {

           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }
           var postParams = $.param(
            {
                "pedido_id":pedidoID,
                "stock":JSON.stringify(stock)
            }
           );
           $http.post('/backend/pedidos/guardarubicacionstock',  postParams  , config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }

       function guardarValidacion(stock_id, unidades_validacion, validacionesHechas, callback)
       {

           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }
           var postParams = $.param(
            {
                "stock_id":stock_id,
                "unidades_validacion":unidades_validacion,
                "validaciones_hechas":JSON.stringify(validacionesHechas)
            }
           );
           $http.post('/backend/pedidos/guardarvalidacionstock',  postParams  , config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }

       function finalizarValidacion(stock_id, pedido_id, callback)
       {

           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }
           var postParams = $.param(
            {
                "stock_id":stock_id,
                "pedido_id":pedido_id
            }
           );
           $http.post('/backend/pedidos/finalizarvalidacionstock',  postParams  , config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }

       function setPedidoAccion(nodeaccion,callback)
       {

           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }
           var postParams = $.param(
            {
                "pedido_id":nodeaccion.pedido_id,
                "accion":JSON.stringify(nodeaccion)
            }
           );
            console.log('setpedidoAccion postParams', postParams)
           $http.post('/backend/pedidos/setpedidoaccion',  postParams  , config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }
       function crearPedido(proveedor_id,pedido,observaciones,callback)
       {
        console.log('crearPedido Service')

           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }
           var postParams = $.param(
            {
                "pedido":JSON.stringify(pedido),
                "observaciones":observaciones,
                "proveedor_id":proveedor_id
            }
           );

           $http.post('/backend/pedidos/setpedido',  postParams  , config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }
       function finalizarPedido(pedidoID,callback)
       {
        console.log('finalizarPedido Service',postParams)

           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }
           var postParams = $.param(
            {
                "pedido_id":pedidoID
            }
           );

           $http.post('/backend/pedidos/setpedidofinalizado',  postParams  , config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }
       function getProductosByProveedor(proveedor_id,callback) 
       {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/pedidos/getproductosbyproveedor',  { params : {proveedor_id:proveedor_id}  }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                    callback(data.data);
            }
       }

       function getTipoCoste(tipocoste_id,callback) 
       {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/pedidos/gettipocoste',  { params : {tipocoste_id:tipocoste_id}  }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                    callback(data.data);
            }
       }

       function getValidacionesStock(material_id, stock_id, callback)
       {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/pedidos/getvalidacionesstock',  { params : {material_id:material_id, stock_id:stock_id}  }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                    callback(data.data);
            }
       }
       function getMovimientosPedido(pedido_id,callback) 
       {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/pedidos/getmovimientospedido',  { params : {pedido_id:pedido_id}  }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                    callback(data.data);
            }
       }
       function getPedidosPendientes(params,callback) {
        console.log('getPedidosPendientes en hoja')
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/pedidos/getpedidospendientes',  { params : params  }  , config)
                .then(getContentSuccess,getContentFailed);
                function getContentSuccess(data){ 
                    callback(data.data);
                }
                function getContentFailed(data){
                    return false;
                }
       }
       function getPedido(pedidoID,callback) {
        console.log('getPedido en PEdidos')
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/pedidos/getpedido',  { params : {pedidoID:pedidoID}  }  , config)
                .then(getContentSuccess,getContentFailed);
                function getContentSuccess(data){ 
                    callback(data.data);
                }
                function getContentFailed(data){
                    return false;
                }
       }
       function liberarStock(stock_id, pedido_id, cantidad_liberar, almacen_id,callback)
       {
           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }
           var postParams = $.param(
            {
                "stock_id":stock_id,
                "pedido_id":pedido_id,
                "cantidad_liberar":cantidad_liberar,
                "almacen_id":almacen_id,
            }
           );

           $http.post('/backend/pedidos/liberarstock',  postParams  , config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }
       function rechazarStock(stock_id, pedido_id, cantidad_liberar, callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var postParams = $.param(
                {
                    "stock_id":stock_id,
                    "pedido_id":pedido_id,
                    "cantidad_liberar":cantidad_liberar,
                }
            )
            $http.post('/backend/pedidos/rechazarstock', postParams, config)
            .then(getContentSuccess, getContentFailed);
            function getContentSuccess(data){
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
       }
        function checkStockPendiente(pedido_id,callback) 
       {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/pedidos/checkstockpendiente',  { params : {pedido_id:pedido_id}  }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                    callback(data.data);
            }
       }

       function getTransportePedido(transporte_id, callback)
       {
            var config = {
                headers : {
                    'Content-Type' : 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/pedidos/gettransportepedido',  { params : {transporte_id:transporte_id}  }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                    callback(data.data);
            }
       }

        function guardarTransportePedido(transporte, divisa_proveedor_id,callback)
       {
           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }
           var postParams = $.param(
            {
                "transporte":JSON.stringify(transporte),
                "divisa_proveedor_id":divisa_proveedor_id
            }
           );

           $http.post('/backend/pedidos/guardartransporte',  postParams  , config)
           .then(getContentSuccess,getContentFailed);
           function getContentSuccess(data){ 
               callback(data.data);
           }
           function getContentFailed(data){
               
               return false;
           }
       }

       function getSameLote(lote_ref, material_id, almacen_id, callback)
       {
            var config = {
                headers : {
                    'Content-Type' : 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/pedidos/getsamelote',  { params : {lote_ref:lote_ref, material_id:material_id, almacen_id:almacen_id}  }  , config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                    callback(data.data);
            }
       }
   }
})();